export var Prefix = '$';
export var StringBound = '!';
export var ValueAssignable = {
    context: "ctx",
    structureMetadata: "md"
};
export var Formats = {
    integer: 'to_i',
    float: 'to_f'
};
